import * as yup from "yup";

import { validator as circumstancesDataValidator } from "./CircumstancesData/validator";
import { validator as driverDataValidator } from "./DriverData/validator";
import { validator as otherPersonsDataValidator } from "./OtherPersonsData/validator";
import { validator as statementsDataValidator } from "./StatementsData/validator";
import { validator as witnessesDataValidator } from "./WitnessesData/validator";

export const validator = yup.object({
  ...circumstancesDataValidator,
  ...driverDataValidator,
  ...statementsDataValidator,
  ...otherPersonsDataValidator,
  ...witnessesDataValidator,
});
